import { useForm } from 'react-hook-form';

import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

import { Input } from '@/components/form/Input';
import { FormBlock } from '@/components/FormBlock';

const fieldSchema = z.object({
  answer: z.string().min(1, 'Campo obrigatório').max(255, 'Máximo de 255 caracteres')
});

type FieldFormValues = z.infer<typeof fieldSchema>;

const FIELD_NAME = 'answer';

export default function TextAnswer() {
  const form = useForm<FieldFormValues>({
    resolver: zodResolver(fieldSchema),
    mode: 'onChange'
  });

  return (
    <FormBlock name='answer' form={form} title='Resposta'>
      <span className='-mb-1 text-sm font-medium'>Resposta para a pergunta acima</span>
      <Input id='answer' placeholder='Digite sua resposta' name={FIELD_NAME} />
      <span className='text-content-body mt-1 text-sm'>Responda de forma breve com suas palavras.</span>
    </FormBlock>
  );
}
